"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledContainer = void 0;
const material_1 = require("@mui/material");
const styles_1 = require("@mui/material/styles");
exports.StyledContainer = (0, styles_1.styled)(material_1.Box)({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    position: "absolute",
    height: "calc(100vh - 64px)",
    width: "100vw",
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    marginTop: "64px",
});
//# sourceMappingURL=styled.js.map